import React from 'react';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <div className="legal-container" style={styles.container}>
      <Helmet>
        <title>Politique de Confidentialité - MulByte</title>
        <meta name="description" content="Comment MulByte collecte et protège vos données personnelles conformément au RGPD" />
      </Helmet>

      <h1 style={styles.title}>Politique de Confidentialité</h1>
      <p className="last-updated" style={styles.updateDate}>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>1. Introduction</h2>
        <p style={styles.paragraph}>
          MulByte ("nous", "notre", "nos") s'engage à protéger la vie privée de ses utilisateurs conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi française n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés.
        </p>
        <p style={styles.paragraph}>
          Cette politique s'applique à tous les services proposés par MulByte, y compris notre site web, nos applications et nos services de développement logiciel.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>2. Données Collectées</h2>
        <p style={styles.paragraph}>Nous collectons différentes catégories de données :</p>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Informations personnelles</strong> : Nom, prénom, email, numéro de téléphone, adresse professionnelle</li>
          <li style={styles.listItem}><strong>Données de projet</strong> : Briefs, spécifications techniques, documents fournis par le client</li>
          <li style={styles.listItem}><strong>Données techniques</strong> : Adresse IP, type de navigateur, historique de navigation, données de cookies</li>
          <li style={styles.listItem}><strong>Données de paiement</strong> : Informations nécessaires au traitement des transactions (stockées sécurisément par notre processeur de paiement)</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>3. Finalités du Traitement</h2>
        <p style={styles.paragraph}>Nous utilisons vos données pour :</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Fournir et améliorer nos services</li>
          <li style={styles.listItem}>Communiquer avec vous concernant vos projets</li>
          <li style={styles.listItem}>Assurer la sécurité de nos services</li>
          <li style={styles.listItem}>Remplir nos obligations légales</li>
          <li style={styles.listItem}>Envoyer des communications marketing (uniquement avec votre consentement)</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>4. Bases Légales du Traitement</h2>
        <p style={styles.paragraph}>Nous nous appuyons sur :</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Votre consentement explicite</li>
          <li style={styles.listItem}>L'exécution d'un contrat</li>
          <li style={styles.listItem}>Notre intérêt légitime (sécurité, amélioration des services)</li>
          <li style={styles.listItem}>Nos obligations légales (facturation, conformité)</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>5. Partage des Données</h2>
        <p style={styles.paragraph}>Nous ne vendons pas vos données. Elles peuvent être partagées avec :</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Sous-traitants nécessaires à l'exécution des services (hébergeurs, outils de développement)</li>
          <li style={styles.listItem}>Autorités légales si requis par la loi</li>
          <li style={styles.listItem}>Prestataires de paiement pour le traitement des transactions</li>
        </ul>
        <p style={styles.paragraph}>Tous nos sous-traitants sont soumis à des accords de confidentialité stricts.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>6. Conservation des Données</h2>
        <p style={styles.paragraph}>Nous conservons vos données :</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Données de compte : 3 ans après la dernière activité</li>
          <li style={styles.listItem}>Données de projet : 5 ans pour conformité légale</li>
          <li style={styles.listItem}>Données de facturation : 10 ans comme exigé par la loi française</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>7. Vos Droits</h2>
        <p style={styles.paragraph}>Conformément au RGPD, vous avez le droit :</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>D'accès à vos données</li>
          <li style={styles.listItem}>De rectification</li>
          <li style={styles.listItem}>À l'effacement ("droit à l'oubli")</li>
          <li style={styles.listItem}>À la limitation du traitement</li>
          <li style={styles.listItem}>À la portabilité des données</li>
          <li style={styles.listItem}>D'opposition</li>
          <li style={styles.listItem}>De retirer votre consentement</li>
        </ul>
        <p style={styles.paragraph}>
          Pour exercer ces droits, contactez notre DPO à <a href="mailto:contact.mulbyte@gmail.com" style={styles.link}>contact.mulbyte@gmail.com</a>.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>8. Sécurité</h2>
        <p style={styles.paragraph}>
          Nous implémentons des mesures techniques et organisationnelles robustes :
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Chiffrement des données (SSL/TLS)</li>
          <li style={styles.listItem}>Sauvegardes régulières</li>
          <li style={styles.listItem}>Contrôle d'accès strict</li>
          <li style={styles.listItem}>Formation du personnel</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>9. Cookies et Traceurs</h2>
        <p style={styles.paragraph}>
          Nous utilisons des cookies nécessaires au fonctionnement et des cookies analytiques (Google Analytics). Vous pouvez les gérer via les paramètres de votre navigateur.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>10. Transferts Internationaux</h2>
        <p style={styles.paragraph}>
          En cas de transfert hors UE, nous nous assurons que les garanties appropriées sont en place (Clauses Contractuelles Types de la Commission Européenne).
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>11. Modifications</h2>
        <p style={styles.paragraph}>
          Nous nous réservons le droit de modifier cette politique. Les changements significatifs seront notifiés par email.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>12. Contact</h2>
        <p style={styles.paragraph}>
          Délégué à la Protection des Données :<br />
          <a href="mailto:contact.mulbyte@gmail.com" style={styles.link}>contact.mulbyte@gmail.com</a><br />
        </p>
      </section>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    color: '#333',
    lineHeight: '1.6',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2c3e50',
    marginBottom: '0.5rem',
    textAlign: 'center',
  },
  updateDate: {
    textAlign: 'center',
    color: '#7f8c8d',
    marginBottom: '2rem',
    fontSize: '0.9rem',
  },
  section: {
    marginBottom: '2rem',
    padding: '1rem',
    backgroundColor: '#f9f9f9',
    borderRadius: '5px',
  },
  sectionTitle: {
    fontSize: '1.5rem',
    color: '#2980b9',
    marginBottom: '1rem',
    borderBottom: '1px solid #eee',
    paddingBottom: '0.5rem',
  },
  paragraph: {
    marginBottom: '1rem',
    fontSize: '1rem',
  },
  list: {
    paddingLeft: '1.5rem',
    marginBottom: '1rem',
  },
  listItem: {
    marginBottom: '0.5rem',
  },
  link: {
    color: '#3498db',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
    },
  },
};

export default PrivacyPolicy;